import React from 'react';
import { TestimonialMarquee } from './TestimonialMarquee';
import { TOP_TESTIMONIALS } from '../data/content';
export function TopTestimonials() {
  return <section aria-label="Customer reviews" className="mx-auto max-w-content px-5 py-8" style={{
    paddingBottom: "0px"
  }} data-id="element-200" data-mp="1pbx68anprq08">
      <TestimonialMarquee testimonials={TOP_TESTIMONIALS} durationSeconds={30} data-id="element-201" data-mp="1ffk4cpi0m5ue" />
    </section>;
}